import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { GeneralASError } from 'src/registry/types/axios';
import { SubscriptionFormSchemaValues } from 'src/features/subscriptions/utils/formSchema';
import { Subscription } from 'src/features/subscriptions/utils/types';

const RESOURCE = '/subscriptions/subscription/:id/';

type MutationFnType = typeof mutationFn;

interface DTO extends SubscriptionFormSchemaValues {
    id: string;
}
const mutationFn = ({ id, ...data }: DTO): Promise<Subscription> => {
    return axios.put(formatResourcePath(RESOURCE, { id }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateSubscription };
